import Axios from "axios";
import { Logger } from "../logging/logger";
import PageConfig from "../utils/PageConfig";

export interface CartClientOptions {
  locale: string;
  shopperId: string;
  authorizationHeader: string;
  vistacartTenant: string;
}

export interface CartItemModel {
  design: {
    documentId?: string;
    documentReferenceUrl?: string;
    editDocumentUrl?: string;
    livePreviewUrl: string;
  };
  merchandisableQuantities: {
    list: number[];
  };
  product: {
    productDisplayName: string;
    productKey: string;
    productVersion: number;
    selectedAttributes: CartItemSelectedAttribute[];
  };
  quantity: number;
  reorderUrl?: string;
}

export interface CartItemSelectedAttribute {
  key: string;
  keyDisplayName?: string;
  value: string;
  valueDisplayName?: string;
}

export default class CartClient {
  private readonly CartClientBaseUrl = "https://vistacart.orders.vpsvc.com";

  public async addToCart(items: CartItemModel[], options: CartClientOptions) {
    const url = this.getCartItemUrl(options);
    if (url) {
      try {
        await Axios.post(
          url,
          { items },
          {
            headers: {
              authorization: options.authorizationHeader,
            },
          }
        );
      } catch (ex) {
        const error = ex as Error;
        Logger.instance.error("Failed to add to cart", {
          errorStack: error.stack,
        });
      }
    }
  }

  private getCartItemUrl(options: CartClientOptions): string {
    if (!options.locale || !options.shopperId) {
      Logger.instance.error("Failed to add to cart. Missing locale and shopperId information.");
      return "";
    }

    return `${this.CartClientBaseUrl}/tenants/${options.vistacartTenant}/carts/${options.shopperId}/v2/items?requestor=${PageConfig.requestor}&locale=${options.locale}`;
  }
}
